<template lang='pug'>
div.map-year-track.mapYearTrack
  | {{mapType}}
  div(
    v-if="yearList"
  ).date Дата:
    span.year {{year}}
      div.track-wrapper
        span.year-start {{min}}
        div.track
          el-slider(
            style="width:100%;"
            :min="min"
            :max="max"
            v-model="year"
            @change="$emit('map-update', year)"
            :step="1"
            show-stops
          )
        span.year-start {{max}}
  div(
    v-else
  ).date
    span.year
      div.track-wrapper
        span.year-start
        div.track {{$translate('Прогнозы не ')}}
        span.year-start
</template>
<script type="text/javascript">

import {map as mapEndpoints} from '../../../api/api-endpoints.js'
import year from '../../../utils/year.js'

export default {
    data() {
        return {year: 0};
    },
    props: {
        mapType: {
            type: String,
            required: true
        },
        route: Object,
    },
    computed: {
        yearList() {
            console.log('cc');
            let data = []
            if (this.$store.getters.readUrlEndpoint(this.getYearListEndpoint())) {
                let endPoint = this.getYearListEndpoint()
                data = this.$store.getters.readUrlEndpoint(endPoint).year
            }
            // выставляем нужный год в самом начале ..
            if (!this.year && data.length > 0) {
            this.year = (+this.route?.query?.year) || year.getCurrentYear();
            }
            return data.sort((a, b) => +a.year - +b.year).map(i => +i.year || +i)
        },
        min() {
            return this.yearList[0]
        },
        max() {
            return this.yearList.slice(-1)[0]
        },
    },
    methods: {
        getYearListEndpoint() {
            return mapEndpoints.yearListForWasteGeoObjects()
        },
        yearHandler (year) {
          this.replaceRoute({ year }, false)
        },
    },
      created() {
        let promises = []
        if (!this.$store.getters.readUrlEndpoint(this.getYearListEndpoint())?.data) {
          promises.push(this.$store.dispatch('updateUrlEndpoint', {
            endpoint: this.getYearListEndpoint()
          }))
          Promise.all(promises)
        }
      }

}
</script>